import htmlIcon from '../../Assets/images/skills/html.png';
import cssIcon from '../../Assets/images/skills/css.png';
import jsIcon from '../../Assets/images/skills/js.png';
// import bootstrapIcon from '../../Assets/images/skills/bootstrap.png';
import reactIcon from '../../Assets/images/skills/react.png';
import vueIcon from '../../Assets/images/skills/vue.png';
import angularIcon from '../../Assets/images/skills/angular.png';
import wordpressIcon from '../../Assets/images/skills/wordpress.png';
import shopifyIcon from '../../Assets/images/skills/shopify.png';
import nextIcon from '../../Assets/images/skills/next.png';
import twIcon from '../../Assets/images/skills/tailwind.png';

import flutterIcon from '../../Assets/images/skills/flutter.png';
import javaIcon from '../../Assets/images/skills/java.png';
// import adIcon from '../../Assets/images/skills/android.png';

import sqlIcon from '../../Assets/images/skills/db.png';

import phpIcon from '../../Assets/images/skills/php.png';
import ciIcon from '../../Assets/images/skills/codeigniter-1.png';
import laravelIcon from '../../Assets/images/skills/laravel.png';
// import zendIcon from '../../Assets/images/skills/zend.png';
import pyIcon from '../../Assets/images/skills/python.png';
import djIcon from '../../Assets/images/skills/django.png';
import nodeIcon from '../../Assets/images/skills/node.png';

import awsIcon from '../../Assets/images/skills/aws.png';
import doIcon from '../../Assets/images/skills/digitalocean.png';
import godaddyIcon from '../../Assets/images/skills/godaddy.png';
import hostingerIcon from '../../Assets/images/skills/hostinger.png';
import googleIcon from '../../Assets/images/skills/google.png';
import seoIcon from '../../Assets/images/skills/seo.png';
import unityIcon from '../../Assets/images/skills/unity.png';
import psIcon from '../../Assets/images/skills/ps.png';
import figmaIcon from '../../Assets/images/skills/figma.png';

export const skillCat = {
	web: {
		categoryName: 'Backend Dev',
		percentage: 40,
		skillList: [
			{ name: 'PHP', xp: '8 YRS', icon: phpIcon },
			{ name: 'Laravel', xp: '8 YRS', icon: laravelIcon },
			{ name: 'Node', xp: '8 YRS', icon: nodeIcon },
			{ name: 'Python', xp: '6 YRS', icon: pyIcon },
			{ name: 'Django', xp: '6 YRS', icon: djIcon },
			{ name: 'SQL', xp: '7 YRS', icon: sqlIcon },
			{ name: 'WordPress', xp: '5 YRS', icon: wordpressIcon },
			{ name: 'Shopify', xp: '5 YRS', icon: shopifyIcon },
			{ name: 'Flutter', xp: '3 YRS', icon: flutterIcon },
			{ name: 'CodeIgniter', xp: '5 YRS', icon: ciIcon },
			{ name: 'Java', xp: '3 YRS', icon: javaIcon },
			{ name: 'Unity', xp: '2 YRS', icon: unityIcon },
			// { name: 'Android', xp: '2 YRS', icon: adIcon },
			// { name: 'Zend Framework', xp: '4 YRS', icon: zendIcon },
		],
	},
	game: {
		categoryName: 'Frontend Dev',
		percentage: 40,
		skillList: [
			{ name: 'HTML', xp: '9 YRS', icon: htmlIcon },
			{ name: 'CSS', xp: '9 YRS', icon: cssIcon },
			{ name: 'Javascript', xp: '10 YRS', icon: jsIcon },
			// { name: 'Bootstrap', xp: '6 YRS', icon: bootstrapIcon },
			{ name: 'React', xp: '9 YRS', icon: reactIcon },
			{ name: 'Next', xp: '6 YRS', icon: nextIcon },
			{ name: 'Vue', xp: '7 YRS', icon: vueIcon },
			{ name: 'Angular', xp: '8 YRS', icon: angularIcon },
			{ name: 'TailwindCSS', xp: '6 YRS', icon: twIcon },

		],
	},
	design: {
		categoryName: 'Web Servie',
		percentage: 20,
		skillList: [
			{ name: 'AWS', xp: '6 YRS', icon: awsIcon },
			{ name: 'Godaddy', xp: '4 YRS', icon: godaddyIcon },
			{ name: 'DigitalOcean', xp: '3 YRS', icon: doIcon },
			{ name: 'Google Service', xp: '3 YRS', icon: googleIcon },
			{ name: 'Hostinger', xp: '5 YRS', icon: hostingerIcon },
			{ name: 'SEO', xp: '4 YRS', icon: seoIcon },
			{ name: 'Photoshop', xp: '3 YRS', icon: psIcon },
			{ name: 'Figma', xp: '3 YR', icon: figmaIcon },
		],
	},
	soft: {
		categoryName: ['Creative', 'Perseverant', 'Patient', 'Enthusiastic', 'Hardworking', 'Amusing'],
		percentage: 100,
	},
};
